module.exports = __webpack_public_path__ + "static/media/19ESCAP52.38818717.jpg";